<script setup>
    /**
     * Vue Scripts
     */
    import {computed, onMounted} from "vue";
    import {searchStore} from "@pinia/search-store";

    /**
     * Vue Components
     */
    import Loading from "@component/Loading/Loading.vue"
    import Trial from "@component/Trial/Trial.vue";
    import {getQueryParams} from "@util/api";
    import Program from "@component/Program/Program.vue";

    const {isHcps} = GLOBAL;
    const {resultsDefault} = TRIALS;
    const {noResults, noTrials, perPage} = resultsDefault || {};

    const store = searchStore();

    const loading = computed(() => store.loading)
    const noTrialsFound = computed(() => store.resultsValues.noTrialsFound)
    const results = computed(() => store.resultsValues.posts)

    onMounted(() => {
        const queryParams = getQueryParams(new URL(window.location).search)

        if (!queryParams.pages) {
            queryParams.page = 1
        }
        else {
            queryParams.page = queryParams.pages
            delete queryParams.pages;
        }

        // Check if trials_id is present but empty in the URL
        if (!queryParams.trials_id && queryParams.trials_id !== '') {
            queryParams.trials_id = 'no_trials_id_param';
        }


        store.$patch({
            query: {
                ppp: perPage || 5,
                page: queryParams.page || 1,
                isHcps,
                ...store.coords,
                ...queryParams,
                search: queryParams.search || '',
            },
            searchedText: queryParams.search
        })

        /**
         * Initial load of the posts
         */
            store.searchApi(
                {
                    ppp: perPage || 5,
                    page: 1,
                    isHcps,
                    ...store.coords,
                    ...queryParams,
                },
                false
            )

    })

    /**
     * Displays the appropriate string if there are
     * no results, or if Antidote returns trial_ids
     * and none are found on the website
     *
     * @returns {*|string}
     */
    const noResultsText = () => {
        const queryParams = getQueryParams(new URL(window.location).search)
        
        if (noTrialsFound.value && queryParams.trials_id && queryParams.trials_id !== 'no_trials_id_param') {
            return noTrials;
        }

        if ((!queryParams.trials_id || queryParams.trials_id === 'no_trials_id_param') &&
            results.value.length === 0) {
            return noResults;
        }



        return ''
    }

</script>

<template>
    <div class="trials-body">
        <!-- Loading Indicator -->
        <Loading :loading="loading" />

        <!-- Trial Results -->
        <div
            v-if="results.length && !loading"
            class="trial-results"
        >
            <!-- Trials -->
            <div
                v-for="trial in results"

                :class="{'group-by-protocol': (trial.children && trial.children.length)}"
                :key="trial.id"

                class="trial-row"
            >
                <Trial
                    v-if="trial.postType === 'trials'"
                    :trial="trial"
                />

                <Program
                    v-if="trial.postType === 'programs'"
                    :trial="trial"
                />

                <!-- Umbrella Protocol Trials -->
                <div
                    v-if="trial.children && trial.children.length"
                    v-for="trial in trial.children"

                    class="sub-studies"
                >
                    <Trial
                        v-if="trial.postType === 'trials'"

                        is-sub-trial
                        :trial="trial"
                    />

                    <Program
                        v-if="trial.postType === 'programs'"

                        is-sub-trial
                        :trial="trial"
                    />

                </div>

            </div>

        </div>

        <!-- No Results -->

        <div
            v-if="!loading && !results.length"
            class="trial-result no-trials-found"
        >
            <div class="row">
                <div class="col-12">
                    <h3
                        class="no-trials-found__text"
                        v-html="noResultsText()"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Search Results"
    }
</script>

<style scoped lang="scss">

</style>
